
<template>
  <header class="header" :class="sticky ? 'sticky': ''">
    <div class="header__branding">
      <img :src="logoSrc" alt="Montebit" />
    </div>
    <div class="header__navigation">
      <Navigation
        :itemsList="itemsList"
        :currentPath="currentPath"
        @actionItem="ItemClick($event)"
        :hasAnchors="true"
      />
    </div>
    <div class="header__burger" @click="burgerClick"></div>
    <Navigation
      ui="mobile"
      v-show="isMenuOpen"
      :itemsList="itemsList"
      :currentPath="currentPath"
      @actionItem="ItemClick($event)"
    />
  </header>
</template>
<script>
import Navigation from "@/components/atoms/NavigationBar.vue";
export default {
  name: "Header",
  components: {
    Navigation,
  },

  props: {
    itemsList: {
      type: Array,
      default: ["item1"],
    },
    ui: {
      type: String,
      default: "simple",
    },
    hasSubmenues: {
      type: Boolean,
      default: false,
    },
  },
  mounted(){
    window.addEventListener("scroll", this.handleScroll);

  },
  beforeUnMount(){
    window.removeEventListener("scroll", this.handleScroll);
  },

  data() {
    return {
      isMenuOpen: false,
      logoSrc: "./montebit-logo.png",
      sticky: false
    };
  },
  methods: {
    ItemClick(value) {
      this.$router.push({ name: "Home", hash: value.pathName });
      this.isMenuOpen = false;
    },
    burgerClick() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleScroll(){
      this.sticky = window.scrollY > 20
    }
  },

  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>